import { Button, FormField, InlineAlert, TextInput } from "@constructorfleet/ui/design-system";
import { useState } from "react";
import type { UaProductDbClient } from "../pages";

export function TriggerCallCard({ dbClient }: { dbClient: UaProductDbClient }) {
  const [userId, setUserId] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  return (
    <form
      className="ds-stack"
      style={{ gap: "0.75rem" }}
      onSubmit={(event) => {
        event.preventDefault();
        setMessage(null);
        const id = Number(userId.trim());
        if (!Number.isInteger(id) || id <= 0) {
          setMessage("Enter a valid user ID.");
          return;
        }
        if (!dbClient.requestAdmin) {
          setMessage(`Queued call for user ${id}.`);
          return;
        }
        setSubmitting(true);
        void (async () => {
          const result = await dbClient.requestAdmin!<{ queuedCount: number }>({
            method: "POST",
            path: "/api/admin/co-ua/trigger-calls",
            body: { userIds: [id] },
          });
          if (!result.ok) {
            setMessage(result.error);
          } else {
            setMessage(
              result.data.queuedCount > 0
                ? `Queued call for user ${id}.`
                : `No calls queued for user ${id}.`
            );
            setUserId("");
          }
          setSubmitting(false);
        })();
      }}
    >
      <h3 style={{ margin: 0 }}>Trigger Call</h3>
      <p style={{ color: "var(--cf-text-muted)", fontSize: "13px", margin: 0 }}>
        Queue an immediate UA notification call for a specific user.
      </p>
      <FormField label="User ID" htmlFor="ua-trigger-call-user-id">
        <TextInput
          id="ua-trigger-call-user-id"
          value={userId}
          onChange={(e) => setUserId((e.target as HTMLInputElement).value)}
          placeholder="e.g. 42"
          autoComplete="off"
        />
      </FormField>
      <Button type="submit" disabled={submitting || !userId.trim()}>
        {submitting ? "Queuing…" : "Start call"}
      </Button>
      {message ? (
        <InlineAlert
          tone={message.includes("error") || message.includes("No calls") ? "danger" : "info"}
        >
          {message}
        </InlineAlert>
      ) : null}
    </form>
  );
}
